import { Component, OnInit } from '@angular/core';
import { MediaService } from './../../services/media.service';
import { AppConfig } from './../../config/app-config';
import { FileSection, FileType, FileData } from './../../models/fileData';
import * as $ from 'jquery';

@Component({
  selector: 'app-media-releases',
  templateUrl: './media-releases.component.html'
})

export class MediaReleasesComponent implements OnInit {

  constructor(private mediaService: MediaService, private appConfig: AppConfig) { }

  //page = 1;
  //pageSize = 12;
  collectionSize = 0;
  AllMedia: any[] = [];
  MediaCategories$: any[] = [];
  MediaList$: any[] = [];
  FeaturedArticle$: any;
  textFilter: string = "";
  selectedCategory$: number = 0;
  

  ngOnInit() {
  }

  getMediaCategoriesList() {
    this.mediaService.getMediaCategoriesList().subscribe((response) => {
      this.MediaCategories$ = response as any[];
    }, (error) => {
      console.error(error);
    });
  }


  getMediaList() {
    this.mediaService.getMediaList().subscribe((response) => {

      this.AllMedia = response as any[];

      this.AllMedia.sort((a, b) => (a.ArticleDate > b.ArticleDate) ? 1 : -1)

      this.MediaList$ = this.AllMedia.filter(x => x.mediaType < 10);
      this.collectionSize = this.AllMedia.length;
      this.getLatestNewsletter();
      $('#loading').hide();
    }, (error) => {
      console.error(error);
    });
    return null;
  }

  getLatestNewsletter() {
    this.FeaturedArticle$ = this.AllMedia.find(x => x.featuredArticle == true);
  }

  ngAfterContentInit() {
    this.getMediaCategoriesList();
    //this.getMediaLocationsList();
    this.getMediaList();
  }

  applyFilters() {

    this.MediaList$ = this.AllMedia.filter(x => x.mediaType < 10);
    const filterText = this.textFilter.toLowerCase();
    let result = [];

    if (this.selectedCategory$ > 0) {
      //category search
      let filteredData = this.AllMedia.filter(x => x.categoryId == this.selectedCategory$);
      result.push(filteredData);
    }

    if (this.textFilter.length > 0) {
      //text search
      result.push(this.AllMedia.filter(x =>
        x.title.toLowerCase().includes(filterText) ||
        x.description.toLowerCase().includes(filterText) ||
        x.tags.toLowerCase().includes(filterText) ||
        x.author.toLowerCase().includes(filterText)
      ));
    }

    if (result.length > 0) {
      let final = [];

      //combine result into one final array
      result.forEach(function (val, ind, arr) {
        final.push(val);
      });

      //remove duplicates from final array
      var unique = final.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });

      this.MediaList$ = unique[0];
    }

    if (this.MediaList$.length == 0) {
      this.MediaList$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.MediaList$.length;
    }

  }

  resetSearch() {
    this.selectedCategory$ = 0;
    //this.selectedLocation$ = 0;
    this.textFilter = "";
    this.MediaList$ = this.AllMedia.filter(x => x.mediaType < 10);
    this.collectionSize = this.MediaList$.length;
  }

}
